import {
  IconApple,
  IconBeer,
  IconBread,
  IconCake,
  IconChefHat,
  IconCoffee,
  IconFish,
  IconGlassChampagne,
  IconGlassFull,
  IconIceCream,
  IconLeaf,
  IconMeat,
  IconPizza,
  IconSalad,
  IconSoup,
  IconToolsKitchen,
  IconToolsKitchen2,
} from "@tabler/icons-react";
import type { MenuIconKey } from "../../utils/menu";

/** Maps each curated menu group icon key to its @tabler glyph. */
const ICONS: Record<MenuIconKey, typeof IconToolsKitchen2> = {
  "welcome-drink": IconGlassChampagne,
  starter: IconToolsKitchen2,
  soup: IconSoup,
  salad: IconSalad,
  bread: IconBread,
  fish: IconFish,
  meat: IconMeat,
  pizza: IconPizza,
  vegetarian: IconLeaf,
  dessert: IconIceCream,
  cake: IconCake,
  fruit: IconApple,
  coffee: IconCoffee,
  wine: IconGlassFull,
  beer: IconBeer,
  buffet: IconChefHat,
  utensils: IconToolsKitchen,
};

/** Renders the glyph for a menu icon key, falling back to utensils. */
export const MenuIcon = ({ iconKey }: { iconKey: string }) => {
  const Icon = ICONS[iconKey as MenuIconKey] ?? IconToolsKitchen;
  return <Icon />;
};
